/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
const CommerceKindList = () =>
  import(
    /* webpackChunkName: "list-commerce-kind" */
    '@/views/CommerceKind/list.vue'
  );

const commerceKindRoutes = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/commerce/category',
      component: CommerceKindList,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default commerceKindRoutes;
